import { render } from "./main-header.vue?vue&type=template&id=757e1afb"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/layout/main-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "757e1afb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('757e1afb', __exports__)) {
    console.log('reload')
    api.reload('757e1afb', __exports__)
  }
  
  module.hot.accept("./main-header.vue?vue&type=template&id=757e1afb", () => {
    console.log('re-render')
    api.rerender('757e1afb', render)
  })

}


export default __exports__